export var Direction;
(function (Direction) {
    Direction["asc"] = "asc";
    Direction["desc"] = "desc";
    Direction["none"] = "none";
})(Direction || (Direction = {}));
//# sourceMappingURL=direction.js.map